<template>
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="12">


        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step
              :complete="step > 1"
              editable
              step="1"
            >
              Select a plan
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              :editable="!_isEmpty(selectedPlan)"
              step="2"
            >
              Payment method
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
              step="3"
              editable
            >
              Review
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-content step="1">
            <v-row
              align="center"
              justify="center"
            >
              <template v-for="(item, index) in plans">
                <v-col
                  :key="`plan_${index}`"
                  cols="4"
                >

                  <v-btn-toggle
                    v-model="selectedPlan"
                  >
                    <v-card>
                      <v-card-title class="text-center">
                        {{ item.nickname }}
                        <v-btn
                          :value="item.id"
                          rounded
                          block
                          :outlined="selectedPlan !== item.id"
                          color="primary"
                          :class="{
                            'accent--text': selectedPlan === item.id
                          }"
                        >
                          Choose plan
                        </v-btn>
                      </v-card-title>
                      <v-card-text>
<!--                        <v-row v-for="(data, id) in getBullets(item.metadata.bullets)">-->
<!--                          <v-col cols="6">-->
<!--                            {{ data.label }}-->
<!--                          </v-col>-->
<!--                          <v-col cols="6">-->
<!--                            {{ data.displayValue }}-->
<!--                          </v-col>-->
<!--                        </v-row>-->
                      </v-card-text>
                    </v-card>
                  </v-btn-toggle>

                </v-col>
              </template>

            </v-row>

            <v-card-actions>
              <v-spacer />

              <v-btn
                :disabled="_isEmpty(selectedPlan)"
                rounded
                outlined
                color="primary"
                @click="step = 2"
              >
                Continue
              </v-btn>
            </v-card-actions>

          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row justify="center" align="center">
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="12" md="8" class="pt-0">
                    <customer-payment-source-select
                      :is-platform="true"
                      :customer="customer"
                      @change-source="onChangePaymentMethod"
                    />
                  </v-col>
                  <v-col cols="12" md="4" class="pt-0">
                    <customer-card-create-dialog
                      :is-platform="true"
                      :customer-id="customer.id"
                      @action="onAddCard"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          rounded
                          outlined
                          block
                          color="primary"
                          v-on="on"
                        >
                          <v-icon small left>add</v-icon>
                          Add Card
                        </v-btn>
                      </template>
                    </customer-card-create-dialog>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer />

              <v-btn
                rounded
                outlined
                @click="step = 1"
              >
                Back
              </v-btn>
              <v-btn
                :disabled="_isEmpty(selectedPaymentMethod)"
                rounded
                outlined
                color="primary"
                @click="step = 3"
              >
                Continue
              </v-btn>
            </v-card-actions>

          </v-stepper-content>

          <v-stepper-content step="3">

            <invoice-summary-card
              :invoice="upcomingInvoice"
            />

            <v-card-actions>
              <v-btn
                rounded
                outlined
                @click="step = 2"
              >
                Back
              </v-btn>
              <v-btn
                rounded
                outlined
                color="primary"
              >
                Pay now
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper>

      </v-col>
    </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { isEmpty, get } from 'lodash'
import CustomerPaymentSourceSelect from "../Common/CustomerPaymentSourceSelect"
import CustomerCardCreateDialog from "../Customer/CustomerCardCreateDialog"
import InvoiceSummaryCard from "../Invoice/InvoiceSummaryCard"

export default {
  components: { InvoiceSummaryCard, CustomerCardCreateDialog, CustomerPaymentSourceSelect },
  props: {
    customer: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    'step'() {
      if(this.step === 3) {
        this.generateUpcomingInvoice()
      }
    }
  },
  computed: {
    ...mapGetters([ 'getPlatformConfig' ]),
    items() {
      return this.plans
    },
    configPlatformProduct() {
      return get(this.platformConfig, 'product')
    }
  },
  async mounted() {
    // fetch plans from config
    this.fetchPlatformPlans()
      .then(res => {
        this.plans = [ ...res.data.data ]
      })
  },
  data() {
    return {
      selectedPlan: null,
      selectedPaymentMethod: null,
      step: '1',
      plans: [],
      platformConfig: {},
      upcomingInvoice: {}
    }
  },
  methods: {
    ...mapActions([ 'fetchPlatformPlans', 'fetchPlatformUpcomingInvoice' ]),
    _isEmpty: val => isEmpty(val),
    generateUpcomingInvoice() {
      const payload = {
        subscription_proration_behavior: 'create_prorations',
        subscription_items:[
          {
            price: this.selectedPlan,
            quantity: 1
          }
        ]
      }

      this.fetchPlatformUpcomingInvoice(payload)
        .then(res => {
          console.log('res', res.data)
          this.upcomingInvoice = res.data
        })
    },
    onAddCard(card) {
      console.log('SOURCE ADDED', card)
    },
    onChangePaymentMethod(val) {
      this.selectedPaymentMethod = val
    },
    getBullets(bulletsString) {
      // bullets is a string from stripe
      // const bullets = JSON.parse(bulletsString)
      //
      // return bullets
      return []
    },
  }
}
</script>
